
const Select2AjaxChoice = function(element) {
    this.element = $(element);
    this.identifier = this.element.attr('data-identifier');
    this.label = this.element.attr('data-label');

    const configs = {};

    if (this.element.attr('data-disable-search') === '1') {
        // configs['minimumResultsForSearch'] = Infinity;
        configs['minimumResultsForSearch'] = -1;
    }

    configs.ajax = {
        url: this.element.attr('data-url'),
        dataType: 'json',
        data: params => {
            const query = {
                search: params.term,
                page: params.page || 1
            };

            this.element.trigger('ajax-query.select2', [ query ]);

            return query;
        },
        processResults: response => {
            this.element.trigger('ajax-response.select2', [ response ]);

            const results = [];

            $.each(response.data, (index, datum) => {
                results.push({
                    id: datum[this.identifier],
                    text: datum[this.label]
                });
            });

            return {
                results: results
            }
        }
    }

    this.element.select2(configs);
}



const select2AjaxChoice = () => {
    const selector = 'select[data-select2-ajax]';

    $(document).arrive(selector, {
        existing: true
    }, function() {
        new Select2AjaxChoice(this);
    });
};

export { select2AjaxChoice }


// WEBPACK FOOTER //
// ./js/form/select2AjaxChoice.js